export { default as Mini } from './mini';
export { default as Lamborghini } from './lamborghini';
export { default as Honda } from './honda';
export { default as Volkswagen } from './volkswagen';
export { default as Mazda } from './mazda';
export { default as LandRover } from './landRover';
